import React, { useState } from 'react';
import { Link, useNavigate, useLocation, useParams } from 'react-router-dom';
import { FiChevronLeft, FiMoreHorizontal, FiPlus } from 'react-icons/fi';
import Dropdown from 'src/app/components/Dropdown';
import MainSidebar from 'src/app/components/Sidebar';
import toast from 'react-hot-toast';
import { useClient } from 'jsonapi-react';
import Swal from 'sweetalert2';
import { useEffect } from 'react';
import { Loader } from '@/components/custom/loader';
import { EmptyState } from '@/components/custom/empty-state';
import { t } from 'i18next';
import IconVerified from 'src/app/components/Icons/IconVerified';
import { useSession } from 'src/app/hooks/useSession';
import usePermission from '@/app/hooks/usePermission';

export default function Sidebar(props) {
  const navigate = useNavigate();
  const { course, currentModuleId, setCurrentModuleId, loading, setCount, selectedTab } = props;
  const client = useClient();
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredModules, setFilteredModules] = useState([]);
  const [click, setClick] = useState(0);
  const { moduleId } = useParams();

  useEffect(() => {
    setCurrentModuleId(window?.history?.state?.moduleId ?? moduleId);
  }, [click]);

  useEffect(() => {
    if (course && course['learning-systems']) {
      const filtered = course['learning-systems'].filter(item => {
        if (searchTerm === '') {
          return true;
        } else if (item.title.toLowerCase().includes(searchTerm.toLowerCase())) {
          return true;
        }
        return false;
      });
      setFilteredModules(filtered);
    }
  }, [course, searchTerm]);

  const deleteModule = async item => {
    const { error } = await client.delete(`learning_systems/${item.id}`);
    if (error) {
      toast.error('Erro ao deletar módulo');
    } else {
      toast.success('Módulo excluido com sucesso!');
      const updatedModulesList = filteredModules.filter(module => module.id !== item.id);
      setFilteredModules(updatedModulesList);
      setCount(prevState => prevState + 1);
      // window.history.pushState({ moduleId: course?.['learning-systems']?.[0]?.id }, '', `/curso/admin/gerenciar/${course?.id}/${course?.['learning-systems']?.[0]?.id}`);
      // setClick(prevState => prevState + 1);
    }
  };

  const shortByCreation = (a, b) => {
    const dateA = new Date(a?.['updated_at']);
    const dateB = new Date(b?.['updated_at']);
    return dateB - dateA;
  };

  filteredModules?.sort(shortByCreation);

  const handleDelete = item => {
    Swal.fire({
      title: t('projects.warningDeleteModule'),
      text: t('projects.warningDeleteCannotBeUndoneText'),
      confirmButtonText: t('button.yes'),
      showDenyButton: true,
      denyButtonText: t('button.no'),
      showCloseButton: true
    }).then(res => {
      if (res.isConfirmed) {
        deleteModule(item);
      }
    });
  };

  const currentUser = useSession()?.session?.user;
  const hasManagePermission = usePermission('Gerenciar conteúdo', 'Cursos');

  const hasModulePermission = module => {
    if (hasManagePermission && (!module?.['authored_by_user'] || (module?.['authored_by_user'] && currentUser.id === module?.['creator_id']) || currentUser?.profileNames.includes('Administrador'))) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <MainSidebar hasBrand={false}>
      <nav className="notebook-sidebar__nav">
        <div className="filter-bar">
          <button
            className="filter-bar__back"
            onClick={() => navigate('/curso/admin')}
          >
            <div className="card__icon-wrapper">
              <FiChevronLeft />
            </div>
            <span
              className="filter-bar__back-container"
              title={course?.title}
            >
              <span className="filter-bar__title">{course?.title}</span>
            </span>
          </button>
        </div>

        <div className="form__row">
          <label
            htmlFor="moduleSearch"
            className="form__label"
          >
            {t('textsCommon.modules')}
          </label>
          <input
            aria-label="Pesquisar módulos"
            className="form__control form__control--search-with-icon"
            placeholder={t('textsCommon.research')}
            type="search"
            name="moduleSearch"
            id="moduleSearch"
            onChange={e => setSearchTerm(e.target.value)}
          />
        </div>

        {course?.id ? (
          <Link to={`/lms/criar/modulo/nome/${course?.id}`}>
            <button className="btn btn--outline-dashed btn--small btn--full">
              <FiPlus className="btn__icon" /> {t('button.newModule')}
            </button>
          </Link>
        ) : (
          <Loader />
        )}

        <hr className="u-hr" />

        <ul className="module-list">
          {loading && <Loader />}
          {filteredModules && !loading && filteredModules.length === 0 && <EmptyState type="data" />}
          {filteredModules &&
            !loading &&
            filteredModules?.map((item, index) => (
              <li
                onClick={() => {
                  if (hasModulePermission(item)) {
                    setClick(prevState => prevState + 1);
                    navigate(`/curso/admin/gerenciar/${course?.id}/${item.id}/${selectedTab}/d`);
                  }
                }}
                className={currentModuleId == item.id ? 'module-list__item active' : 'module-list__item'}
                key={index}
                style={!hasModulePermission(item) ? { cursor: 'default' } : {}}
              >
                <h3 className="module-list__title">
                  {item?.official_content && <IconVerified />} {item.title}
                </h3>

                <Dropdown>
                  <Dropdown.Toggle>
                    <FiMoreHorizontal />
                  </Dropdown.Toggle>

                  <Dropdown.Content>
                    <Dropdown.Item
                      onClick={() => {
                        navigate(`/show-course/${item.id}/classroom`);
                      }}
                    >
                      {t('button.view')}
                    </Dropdown.Item>
                    {hasModulePermission(item) && (
                      <>
                        <Dropdown.Item
                          onClick={() => {
                            navigate(`/lms/criar/modulo/nome/${item.id}/${course?.id}`);
                          }}
                        >
                          {t('button.edit')}
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() => {
                            handleDelete(item);
                          }}
                        >
                          {t('button.delete')}
                        </Dropdown.Item>
                      </>
                    )}
                  </Dropdown.Content>
                </Dropdown>
              </li>
            ))}
        </ul>
      </nav>
    </MainSidebar>
  );
}
